import script from "./ChatAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./ChatAvatar.vue?vue&type=style&index=0&id=2469a8c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2469a8c6"]])

export default __exports__